"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendParentError = exports.sendParentDone = exports.setProvider = exports.setWaitlist = void 0;
const xstate_1 = require("xstate");
const Events_1 = require("../../../lib/constants/Events");
// Action constants
const setWaitlist = '@action/SET_WAITLIST_DATA';
exports.setWaitlist = setWaitlist;
const setProvider = '@action/SET_PROVIDER';
exports.setProvider = setProvider;
const sendParentDone = '@action/SEND_PARENT_DONE';
exports.sendParentDone = sendParentDone;
const sendParentError = '@action/SEND_PARENT_ERROR';
exports.sendParentError = sendParentError;
// Actions object using string constants as keys, with explicit typing
const actions = {
    [setWaitlist]: (0, xstate_1.assign)({
        waitlist: (_, event) => event.data.result
    }),
    [setProvider]: (0, xstate_1.assign)({
        provider: (_, event) => event.data
    }),
    [sendParentDone]: (0, xstate_1.sendParent)((context) => {
        return {
            type: Events_1.LOADING_DONE,
            data: {
                provider: context.provider,
                waitlist: context.waitlist
            }
        };
    }),
    [sendParentError]: (0, xstate_1.sendParent)(() => {
        return {
            type: Events_1.LOADING_ERROR
        };
    })
};
exports.default = actions;
//# sourceMappingURL=actions.loadingMachine.js.map